import React from 'react';
import useNav from 'hooks/useNav';
import { RouteId } from 'types/frontend_models/navigation/RouteId';
import { productsPageRoutes } from 'components/navigation/routes';
import { Route } from 'react-router-dom';


export function ProductsPage()
{
	useNav({ routeId: RouteId.products });

	return (
		<div className="products-page">
			{
				productsPageRoutes.map((route, index) => (
					<Route
						key={route.routeId}
						path={route.path}
						exact={route.exact}
						component={route.component}
					/>
				))
			}
		</div>
	);
};